export default {
  Titulo: "Rede SIM",
  Campos: {
    NumeroProtocolo: {
      Tipo: 'text',
      Label: 'Número Protocolo',
      Tooltip: 'Número do Protocolo',
      Placeholder: 'Número Protocolo',
      BootstrapColuna: 4,
      Obrigatorio: true,
      Tamanho: 13,
    },
    CpfCnpjSolicitante: {
      Tipo: "mask",
      Mascara: "CPFCNPJ",
      Label: "CPF/CNPJ Solicitante",
      BootstrapColuna: 4,
      Obrigatorio: true,
    },
    NomePessoa: {
      Tipo: 'text',
      Label: 'Nome Solicitante',
      Tooltip: 'Nome Solicitante',
      Placeholder: 'Nome Solicitante',
      BootstrapColuna: 4,
      Obrigatorio: true,
    },
    CnpjEmpresa: {
      Tipo: "mask",
      Mascara: "CNPJ",
      Label: "CNPJ Empresa",
      BootstrapColuna: 4,
      Obrigatorio: true,
    },
    NomeEmpresa: {
      Tipo: 'text',
      Label: 'Nome Empresa',
      Tooltip: 'Nome Empresa',
      Placeholder: 'Nome Empresa',
      BootstrapColuna: 4,
      Obrigatorio: true,
    },
    Ccm: {
      Tipo: 'text',
      Label: 'CCM',
      Tooltip: 'CCM',
      Placeholder: 'CCM',
      BootstrapColuna: 1,
      Obrigatorio: true,
    },
  }
};
